/**
 * Simple implementation of a event pub-sub
 */
const eventBus = {
  _bus: {} as any,
  on(name: string, callback: Function) {
    this._bus[name] = callback;
  },
  off(name: string) {
    delete this._bus[name];
  },
  emit(name: string, ...args: any[]) {
    this._bus[name]?.(...args);
  },
};

export default eventBus;
